import React from "react";
import "../styles/About.css";
import FadeInSection from "./FadeInSection";

class About extends React.Component {
  constructor() {
    super();
    this.state = {
      expanded: true,
      activeKey: "1",
    };
    this.handleSelect = this.handleSelect.bind(this);
  }
  handleSelect(eventKey) {
    this.setState({
      activeKey: eventKey,
    });
  }
  render() {
    const one = (
      <p>
        I am currently a <b>Customer Support</b> at
        <a
          href="https://templeosonline.com/"
          className="about-link-classified"
          target="_blank"
          rel="noopener noreferrer"
        >
          ‎ Classified
        </a>, where I help people
        with their different issues. I have a designer’s eye for reimagining my surroundings. 
        I love movies that pair a peaceful, mysterious atmosphere with a mind-bending plot twist.
      </p>
// <a href="https://templeosonline.com/"> Classified</a>, where I help people

    );
    const two = (
      <p>
        Outside of work, I like to get outdoors and enjoy the weather.     
        Oh, and I also spend my time listening to music and playing games.
      </p>
    );

    const tech_stack = [
      "Python",
      "Typescript",
      "React.js",
      "Java",
      "Javascript",
      "C#",
      "C++",
      "HTML",
      "CSS",
      "SQL",
      "GitHub",
      "QA Engineering"
    ];

    return (
      <div id="about">
        <FadeInSection>
          <div className="section-header ">
            <span className="section-title">/ about me</span>
          </div>
          <div className="about-content">
            <div className="about-description">
              {[one]}
              <b>{"I have had experience with:"}</b>
              <ul className="tech-stack">
                {tech_stack.map(function (tech_item, i) {
                  return (
                    <FadeInSection delay={`${i + 1}00ms`}>
                      <li>{tech_item}</li>
                    </FadeInSection>
                  );
                })}
              </ul>
              {[two]}
            </div>
            <div className="about-image">
              <img
                className="about-image__portrait"
                alt="Portrait"
                src="/assets/me.jpg"
              />
            </div>
          </div>
        </FadeInSection>
      </div>
    );
  }
}

export default About;
